(function () {
  const initMegaSubmenu = (header) => {
    const megaSubmenuLinks = header.querySelectorAll(".list-menu--megasubmenu");
    if (!megaSubmenuLinks || !megaSubmenuLinks.length) return;

    megaSubmenuLinks.forEach((link) => {
      const tabs = link.querySelectorAll(".mega-submenu__tab");
      const submenus = link.querySelectorAll(".mega-submenu__submenu");

      const onToggle = (event) => {
        const tab = event.target;
        if (!tab || !tab.classList.contains("mega-submenu__tab")) return;
        const tabId = tab.dataset.tabId;
        tabs.forEach((tab) => {
          tab.classList.remove("active");
        });
        tab.classList.add("active");
        submenus.forEach((submenu) => {
          submenu.classList.remove("active");
          if (submenu.dataset.tabId === tabId) {
            submenu.classList.add("active");
          }
        });
      };

      tabs.forEach((tab) => {
        tab.addEventListener("click", onToggle);
        tab.addEventListener("mouseenter", onToggle);
      });
    });
  };

  const links_with_image = () => {
    let containers = document.querySelectorAll(".header__full-screen-menu");

    containers.forEach((container) => {
      let images = container.querySelectorAll(
        ".header__full-screen-menu__image-wrapper"
      );
      let links = container.querySelectorAll(
        ".header__full-screen-menu__placeholder"
      );
      let items = container.querySelectorAll(".header__full-screen-menu__item");

      images.forEach((image, index) => {
        let isFirst = index === 0;

        image.style.opacity = isFirst ? 1 : 0;
        image.style.zIndex = isFirst ? 1 : 0;
        image.style.transition = "opacity 1s ease";
      });

      items.forEach((item, index) => {
        let isFirst = index === 0;

        item.style.opacity = isFirst ? 1 : 0.4;
      });

      let fadeImages = (index) => {
        images.forEach((image, i) => {
          let isCurrent = i === index;

          image.style.opacity = isCurrent ? 1 : 0;
          image.style.zIndex = isCurrent ? 1 : 0;
        });

        items.forEach((item, i) => {
          let isCurrent = i === index;

          item.style.opacity = isCurrent ? 1 : 0.4;
        });
      };

      links.forEach((link, index) => {
        link.addEventListener("mouseenter", () => fadeImages(index));
        link.addEventListener("focusin", () => fadeImages(index));
      });

      container.addEventListener("mouseleave", () => fadeImages(0));
      container.addEventListener("focusout", (e) => {
        if (!container.contains(e.relatedTarget)) fadeImages(0);
      });
    });
  };

  const header = () => {
    const header = document.querySelector(".shopify-section-header");
    const search = document.querySelector(".header__search");
    const menuLinks = document.querySelectorAll(".list-menu-item");

    header.addEventListener("keydown", (e) => {
      if (e.code === "Escape" && search.isOpen) {
        search.close();
      }
    });

    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);

    const annBar = document.querySelector(".section-announcement");
    const annBarObserver = new IntersectionObserver(
      (entries) => {
        const [entry] = entries;

        if (entry.isIntersecting) {
          document.documentElement.style.setProperty(
            "--ann-height",
            `${entry.intersectionRect.height}px`
          );
        } else {
          document.documentElement.style.setProperty("--ann-height", `0px`);
        }
      },
      {
        threshold: 1,
      }
    );
    if (annBar) annBarObserver.observe(annBar);

    menuLinks.forEach((link) => {
      link.addEventListener("mouseover", (e) => {
        if (link.classList.contains("list-menu--full_screen_menu")) {
          link.classList.add("active");
          header.classList.add("color-background-3");
        }
      });

      link.addEventListener("mouseout", (e) => {
        if (link.classList.contains("list-menu--full_screen_menu")) {
          header.classList.remove("color-background-3");
          link.classList.remove("active");
        }
      });

      link.addEventListener("focusin", () => {
        if (link.classList.contains("list-menu--full_screen_menu")) {
          link.classList.add("active");
          header.classList.add("color-background-3");
        }
      });

      link.addEventListener("focusout", () => {
        if (link.classList.contains("list-menu--full_screen_menu")) {
          header.classList.remove("color-background-3");
          link.classList.remove("active");
        }
      });
    });

    window.addEventListener("scroll", () => {
      menuLinks.forEach((link) => {
        if (link.classList.contains("list-menu--full_screen_menu")) {
          header.classList.remove("color-background-3");
          link.classList.remove("active");
        }
      });
    });

    const addBackground = () => {
      if (document.querySelector(".overflow-hidden-drawer")) {
        return;
      }

      if (document.querySelector(".always-show")) {
        return;
      }

      let full_screen_menu_hover = false;
      let full_screen_menu_focus = false;

      menuLinks.forEach((link) => {
        if (link.classList.contains("list-menu--full_screen_menu")) {
          link.addEventListener("mouseenter", () => {
            full_screen_menu_hover = true;
          });

          if (
            document.activeElement ==
              link.querySelector(".header__menu-item") ||
            document.activeElement ==
              link.querySelector(".header__full-screen-menu__item") ||
            document.activeElement ==
              link.querySelector(".header__full-screen-menu__button")
          ) {
            full_screen_menu_focus = true;
          }
        }
      });

      const headerObserver = new ResizeObserver((entries) => {
        const [entry] = entries;
        if (entry.contentRect.width >= 1100) {
          if (
            header.classList.contains("color-background-3") &&
            !header.classList.contains("shopify-section-header-sticky")
          ) {
            if (full_screen_menu_hover || full_screen_menu_focus) {
              return;
            }
            header.classList.remove("color-background-3");
          }
        }
      });

      headerObserver.observe(header);
    };

    const removeBackground = () => {
      if (
        document.querySelector(".overflow-hidden") ||
        document.querySelector(".overflow-hidden-drawer")
      ) {
        return;
      }

      if (document.querySelector(".always-show")) {
        return;
      }

      const headerObserver = new ResizeObserver((entries) => {
        const [entry] = entries;
        if (entry.contentRect.width >= 1100) {
          if (
            header.classList.contains("color-background-1") &&
            !header.classList.contains("shopify-section-header-sticky")
          ) {
            header.classList.add("color-background-3");
          }
        }
      });

      headerObserver.observe(header);
    };

    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    header.addEventListener("mouseenter", addBackground);
    header.addEventListener("mouseleave", removeBackground);

    if (!isSafari) {
      header.addEventListener("focus", addBackground);
      header.addEventListener("focusin", addBackground);
      header.addEventListener("focusout", removeBackground);
    }

    const main = document.querySelector("main");
    const breadcrumbs = document.querySelector(".breadcrumbs-wrapper");
    if (
      main
        .querySelectorAll(".shopify-section")[0]
        ?.classList.contains("section--has-overlay") &&
      !main
        .querySelectorAll(".shopify-section")[0]
        ?.classList.contains("not-margin")
    ) {
      header.classList.add("color-background-1", "color-background-3");
      if (breadcrumbs) {
        breadcrumbs.classList.add("color-background-3");
      }
    }

    initMegaSubmenu(header);
  };

  header();
  links_with_image();

  document.addEventListener("shopify:section:load", header);
  document.addEventListener("shopify:section:unload", header);
  document.addEventListener("shopify:section:reorder", header);
})();
